export const T15 = {
    "columns": 12,
    "rows": 2,
    "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": "colorTheme1",
        "title": "Product Sales by Channel (PESO)",
        "binding": {
            "data": {
                "columns": [
                    {
                        "name": 'Principal Code',
                        "columnName": 'DistributorCode',
                        "width": '150px',
                        "align": "left",
                        "sortable": true,
                        "sum": false
                    },
                    {
                        "name": 'Sales (PESO)',
                        "columnName": 'ActualSales(Value)',
                        "width": '140px',
                        "align": "right",
                        "sortable": true,
                        "sum": true
                    },
                    {
                        "name": 'LYSales (PESO)',
                        "columnName": 'LYSales(Value)',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": true
                    },
                    {
                        "name": '% Growth (PESO)',
                        "columnName": 'Growth(Value)',
                        "width": '170px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    {
                        "name": 'Sales (UNIT)',
                        "columnName": 'ActualSales(Qty)',
                        "width": '140px',
                        "align": "right",
                        "sortable": true
                    },
                    {
                        "name": 'LYSales (UNIT)',
                        "columnName": 'LYSales(Qty)',
                        "width": '150px',
                        "align": "right",
                        "sortable": true
                    },
                    {
                        "name": '% Growth (UNIT)',
                        "columnName": 'Growth(Qty)',
                        "width": '170px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    }
                ],
                "title": 'DistributorName',
                "endpoint": "T15",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "AgentCode", "value": "" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {
                        "selectedValueColumn": "DistributorCode",
                        "visuals": [
                            {
                                "title": "Product",
                                "visual": [
                                    {
                                        "columns": 12,
                                        "rows": 2,
                                        "visual": {
                                            "id": 1,
                                            "type": "advancedTable",
                                            "colorTheme": "colorTheme1",
                                            "title": "Product",
                                            "binding": {
                                                "data": {
                                                    "columns": [
                                                        {
                                                            "name": 'Product Name',
                                                            "columnName": 'ItemName',
                                                            "width": '250px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false
                                                        },
                                                        {
                                                            "name": 'Sales (PESO)',
                                                            "columnName": 'ActualSales(Value)',
                                                            "width": '140px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": 'LYSales (PESO)',
                                                            "columnName": 'LYSales(Value)',
                                                            "width": '150px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": '% Growth (PESO)',
                                                            "columnName": 'Growth(Value)',
                                                            "width": '170px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": false,
                                                            "percent": true
                                                        },
                                                        {
                                                            "name": 'Sales (UNIT)',
                                                            "columnName": 'ActualSales(Qty)',
                                                            "width": '140px',
                                                            "align": "right",
                                                            "sortable": true
                                                        },
                                                        {
                                                            "name": 'LYSales (UNIT)',
                                                            "columnName": 'LYSales(Qty)',
                                                            "width": '150px',
                                                            "align": "right",
                                                            "sortable": true
                                                        },
                                                        {
                                                            "name": '% Growth (UNIT)',
                                                            "columnName": 'Growth(Qty)',
                                                            "width": '170px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": false,
                                                            "percent": true
                                                        }
                                                    ],
                                                    "title": 'ItemName',
                                                    "endpoint": "T15.2",
                                                    "parameters": [
                                                        { "key": "FromMonth", "value": "2024" },
                                                        { "key": "FromYear", "value": "1" },
                                                        { "key": "ToMonth", "value": "2024" },
                                                        { "key": "ToYear", "value": "1" },
                                                        { "key": "AgentCode", "value": "" },
                                                        { "key": "DistributorCode", "value": "" },
                                                        { "key": "ConfigTypeCode", "value": "" }
                                                    ]
                                                },
                                                "context": {
                                                    "point": {
                                                        "onClick": {

                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                }
            }
        }
    }
}